<template lang="pug">
v-card.mb-3
  v-card-title.lighten-4.grey(v-if="extra && extra.options && extra.options.show_panel_title")
    .title {{extra.name}}
  v-card-text
    template(v-if="msg")
      v-alert.mb-3(:value="true" type="success") {{msg}}
    template(v-if="error")
      v-alert.mb-3(:value="true" type="error") {{error}}
    template(v-if="finished")
    template(v-else-if="user && false")
      v-text-field(label="E-Mail" :value="user.email" disabled :error-messages="gqlErrorsFor('pwReset', 'email')")
      v-text-field(label="Altes Passwort" v-model="oldPassword" :error-messages="gqlErrorsFor('pwReset', 'oldPassword')")
      v-text-field(label="Neues Passwort" v-model="password" type="password" :error-messages="gqlErrorsFor('pwReset', 'password')")
      v-text-field(label="Neues Passwort Bestätigen" v-model="passwordConfirmation" type="password" :error-messages="gqlErrorsFor('pwReset', 'passwordConfirmation')")
    template(v-else)
      template(v-if="request")
          v-text-field(label="E-Mail" v-model="email" :error-messages="gqlErrorsFor('pwReset', 'email')")
          v-btn(@click="doRequest") Passwort-Rücksetzschlüssel beantragen
          v-btn(@click="cancel") Abbrechen
      template(v-else-if="reset")
        v-text-field(label="E-Mail" v-model="email" :error-messages="gqlErrorsFor('pwReset', 'email')")
        v-text-field(label="Passwort-Rücksetzschlüssel" v-model="resetToken" :error-messages="gqlErrorsFor('pwReset', 'resetToken')")
        v-text-field(label="Neues Passwort" v-model="password" type="password" :error-messages="gqlErrorsFor('pwReset', 'password')")
        v-text-field(label="Neues Passwort Bestätigen" v-model="passwordConfirmation" type="password" :error-messages="gqlErrorsFor('pwReset', 'passwordConfirmation')")
        v-btn(@click="doReset") Passwort zurücksetzen
        v-btn(@click="cancel") Abbrechen
      template(v-else)
        v-btn(@click="request = true" block) Ich habe mein Passwort vergessen
        v-btn(@click="reset = true" block) Ich habe einen Passwort-Rücksetzschlüssel

</template>

<style lang="stylus" scoped>

</style>

<script>
import gql from 'graphql-tag'
import GraphqlErrorObject from '../../mixins/graphql-error-object.js'
import { menus, user } from '../../router'

export default {
  props: ['extra'],
  mixins: [GraphqlErrorObject],
  data() {
    return {
      user,
      email: '',
      resetToken: '',
      oldPassword: '',
      password: '',
      passwordConfirmation: '',
      request: false,
      reset: false,
      finished: false,
      msg: null,
      error: null,
    }
  },
  beforeDestroy() {
    this.clear()
  },
  computed: {
  },
  methods: {
    clear() {
      this.email = ''
      this.resetToken = ''
      this.oldPassword = ''
      this.password = ''
      this.passwordConfirmation = ''
    },
    cancel() {
      this.clear()
      this.msg = null
      this.error = null
      this.reset = false
      this.request = false
    },
    doRequest() {
      this.gqlClearAllErrors()
      this.error = ''
      this.msg = ''
      this.$apollo.mutate({
        mutation: gql`mutation passwordResetVueRequest($email: String) {
          pwReset: passwordResetTokenCreate(email: $email) {
            success
            recipient
          }
        }`,
        variables: {
          email: this.email
        },
      }).then((response) => {
        if (response && response.data && response.data.pwReset && response.data.pwReset.success) {
          this.msg = `Kontaktiere ${response.data.pwReset.recipient} um deinen Passwort-Rücksetzschlüssel zu erhalten`
          this.request = false
          this.reset = true
        } else {
          this.error = 'Ein Fehler ist aufgetreten'
        }
      }, (error) => {
        this.gqlAddErrors(error)
        this.error = this.gqlErrorsFor('pwReset')[0] || 'Ein Fehler ist aufgetreten'
      })
    },
    doReset() {
      this.gqlClearAllErrors()
      this.error = ''
      this.msg = ''
      this.$apollo.mutate({
        mutation: gql`mutation passwordResetVueRequest(
          $email: String
          $passwordResetToken: String
          $oldPassword: String
          $password: String
          $passwordConfirmation: String
        ) {
          pwReset: passwordResetTokenUse(
            email: $email
            passwordResetToken: $passwordResetToken
            oldPassword: $oldPassword
            password: $password
            passwordConfirmation: $passwordConfirmation
          ) {
            success
          }
        }`,
        variables: {
          email: this.email,
          passwordResetToken: this.resetToken,
          oldPassword: this.oldPassword,
          password: this.password,
          passwordConfirmation: this.passwordConfirmation,
        },
      }).then((response) => {
          if (response && response.data && response.data.pwReset && response.data.pwReset.success) {
            this.clear()
            this.msg = `Passwort wurde geändert`
            this.reset = false
            this.finished = true
          } else {
            this.error = 'Ein Fehler ist aufgetreten'
          }
      }, (error) => {
        this.gqlAddErrors(error)
        this.error = this.gqlErrorsFor('pwReset')[0] || 'Ein Fehler ist aufgetreten'
      })
    },
  }
}
</script>
